import ServiceLocator from 'live/services/service-locator'

import './admin'
import './editor'
import './sideview'

import channelAlarmsService from './services/channelAlarmsService'

ServiceLocator.registerService('plugin-channel-alarms:channel-alarms', channelAlarmsService)
